import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-peoplehr',
  name: 'Access PeopleHR',
  category: 'access-integrations',
  description: 'PeopleHR integration for HR management and employee data',
  icon: 'Users',
  color: 'blue',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  credentials: [
    {
      name: 'peoplehr',
      required: true,
    },
  ],
  tags: ['access', 'peoplehr', 'hr', 'employees', 'absence', 'holiday', 'salary'],
};

export default definition;
